// extracted by mini-css-extract-plugin
module.exports = {"timelineItem":"styles_timelineItem__wif7q","content":"styles_content___2ZKO"};